module.exports = __webpack_public_path__ + "img/fechar-circulo.e975a459.svg";